export default "__VITE_ASSET__599b8087__"